"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.fetchInfoExist = exports.extractFetchInfo = void 0;
var _hasProp = require("./hasProp");
// Stricter: check config is object before accessing
function getStringProp(error, prop, configProp) {
  if ((0, _hasProp.hasProp)(error, prop) && typeof error[prop] === 'string') {
    return error[prop];
  }
  if (configProp && (0, _hasProp.hasProp)(error, 'config')) {
    const {
      config
    } = error;
    if (typeof config === 'object' && config !== null && configProp in config && typeof config[configProp] === 'string') {
      return config[configProp];
    }
  }
  return undefined;
}
function getNumberProp(error, prop, fallbackProp) {
  if ((0, _hasProp.hasProp)(error, prop) && typeof error[prop] === 'number') {
    return error[prop];
  }
  if (fallbackProp && (0, _hasProp.hasProp)(error, fallbackProp) && typeof error[fallbackProp] === 'number') {
    return error[fallbackProp];
  }
  return undefined;
}
function isObject(val) {
  return typeof val === 'object' && val !== null;
}
const fetchInfoExist = err => {
  if (!isObject(err)) {
    return false;
  }
  if ('fetchInfo' in err && err.fetchInfo !== undefined) {
    return true;
  }
  if ('cause' in err && err.cause !== undefined) {
    return fetchInfoExist(err.cause);
  }
  return false;
};
exports.fetchInfoExist = fetchInfoExist;
const getResponseBodyProp = error => {
  // Try responseBody prop directly (for custom error objects)
  if ((0, _hasProp.hasProp)(error, 'responseBody')) {
    return error.responseBody;
  }

  // Try Axios error shape: error.response.data
  if ((0, _hasProp.hasProp)(error, 'response')) {
    const {
      response
    } = error;
    if (isObject(response) && (0, _hasProp.hasProp)(response, 'data')) {
      return response.data;
    }
  }
  return undefined;
};
const extractFetchInfo = error => ({
  graphqlQuery: getStringProp(error, 'graphqlQuery'),
  variables: (0, _hasProp.hasProp)(error, 'variables') ? error.variables : undefined,
  baseUrl: getStringProp(error, 'baseUrl', 'baseURL'),
  url: getStringProp(error, 'url', 'url'),
  pathname: getStringProp(error, 'pathname', 'url'),
  method: getStringProp(error, 'method', 'method'),
  statusCode: getNumberProp(error, 'statusCode', 'status'),
  statusText: getStringProp(error, 'statusText', 'code'),
  responseBody: getResponseBodyProp(error)
});
exports.extractFetchInfo = extractFetchInfo;
